import { CUSTOM_CROP_INPUT_CLASS_NAME } from './ImageEditor.constants';

export function createCustomCropWidgets(lastButton, onClick) {
  const additionalCroppingRatios = ['9:16', '2:3', '4:5'];

  additionalCroppingRatios.forEach((ratio) => {
    const clone = lastButton.cloneNode(true);

    clone.classList.add(CUSTOM_CROP_INPUT_CLASS_NAME);
    clone.querySelector('label').textContent = ratio;
    clone.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        const [width, height] = ratio.split(':').map(Number);
        const computedRatio = width / height;

        onClick(computedRatio);
      },
      true,
    );

    lastButton.parentNode.appendChild(clone);
  });
}
